import React from 'react'
import Chart from 'react-apexcharts'

const RadialChart = (props) => {
    const option = {
        chart: {
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 15,
                    size: '70%',
                },
                track: {
                    background: '#000',
                },
                dataLabels: {
                    name: {
                        show: false,
                    },
                    value: {
                        show: false,
                    },
                },
            },
        },
        fill: {
            colors: [props.color ? props.color : '#2F6BAF'],
        },
        series: [props.chartValue],
        labels: [''],
    }
    return (
        <div className="donut">
            <Chart
                options={option}
                series={option.series}
                type="radialBar"
                height="290"
                width="100%"
            />
        </div>
    )
}

export default RadialChart
